import { css } from '@emotion/react';
import styled from '@emotion/styled';
import { Colors } from '@utex/ui-kit';

export const Icon = styled('img')`
  margin-bottom: 2rem;
`;

export const borderBottom = css`
  border-bottom: 1px solid ${Colors.ut.border10};
  margin-bottom: 1rem;
  padding-bottom: 1rem;
`;

export const marginBottom = css`
  margin-bottom: 2rem;
`;
